/**
 * Actions for app messages
 *
 * @author Mamontov Andrey, 08/2018
 */


import { Action } from '@ngrx/store';

export const MESSAGE_SUCCESS = '[Messages] Success Message';
export const MESSAGE_ERROR = '[Messages] Error Message';
export const MESSAGE_CLEAR_ALL = '[Messages] Clear Messages';
export const MESSAGE_SYSTEM = '[Messages] System Message';

export class SuccessMessage implements Action {
  readonly type = MESSAGE_SUCCESS;
  constructor(public payload: string) { }
}

export class ErrorMessage implements Action {
  readonly type = MESSAGE_ERROR;
  constructor(public payload: string) { }
}

export class SystemMessage implements Action {
  readonly type = MESSAGE_SYSTEM;
  constructor(public payload: string) { }
}

export class ClearMessages implements Action {
  readonly type = MESSAGE_CLEAR_ALL;
  constructor() { }
}

export type Action = SuccessMessage | ErrorMessage | ClearMessages | SystemMessage;
